export const environment = {
  production: true,
  buildId: '2728021389118641',
  configFile: 'config.json',
};
